import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsVG: CultureInfo = {
  name: 'es-VG',
  displayName: 'español (Islas Vírgenes Británicas)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-VG',
  parent: CultureInfoEs
};
